import { useEffect } from 'react'

import ResourceCard from '@/features/resource/components/ResourceCard'
import ResourceSupportToolbox from '@/features/resource/components/ResourceSupportToolbox'
import { ResourceRouteInformation } from '@/features/resource/constants'
import { useResourceData } from '@/features/resource/contexts/ResourceDataContext'
import { useResourceDetails } from '@/features/resource/pages/ResourceDetailsPage'

const ResourceSupportToolboxPage = () => {
  const { setActivePage } = useResourceDetails()

  useEffect(() => {
    setActivePage(ResourceRouteInformation.RESOURCE_SUPPORT_TOOLBOX.routePath)
  }, [setActivePage])

  const { resource } = useResourceData()
  if (!resource) {
    return null
  }

  return <ResourceCard content={<ResourceSupportToolbox resource={resource} />} />
}

export default ResourceSupportToolboxPage
